export default {
	"SeckillComponent.HotRush": "火熱搶購中",
	"SeckillComponent.ComingSoon": "即將開始",
	"SeckillComponent.OnlyTheEndIsLeft": "距離結束只剩",
	"SeckillComponent.LimitedTimeSpikes": "限時秒殺",
	"SeckillComponent.sky": "天"
}